export const PASSWORD = 'Придумайте пароль';
export const AUTHORIZATION_PROBLEM = 'Проблемы с авторизацией?';
export const ADMINISTRATOR = 'Обратитесь к администратору ';
export const EMAIL = 'edu@fond-igra.ru';
export const LETTER_SENT = 'Письмо отправлено';
export const MESSAGE_TEXT_PASSWORD = 'Мы отправили письмо с ссылкой для восстановления пароля на ';
export const PASSWORD_PROBLEM = 'Проблемы с восстановлением пароля?';
export const REGISTRATION = 'Регистрация';
export const YOUR_LOGIN = 'Ваш логин';
export const CONFIRMATION_PASSWORD = 'Подтвердите пароль';
export const REGISTRATION_BTN = 'Зарегистрироваться';
export const MESSAGE_TEXT_EMAIL = 'Мы отправили письмо для подтверждения почтового адреса на ';
export const INVALID_LINK = 'Ссылка недействительна';
export const NEW_LINK = 'Новую ссылку нужно запросить у администратора';
export const OLD_LINK = 'по старой ссылке регистрация невозможна';
export const HELP_INFO = 'Если письмо не пришло, проверьте папку спам';
export const ADMIN_REG = 'или обратитесь к администратору ';
export const REGISTRATION_PROBLEM = 'Проблемы с регистрацией?';
export const ERROR_LINK_EMAIL = 'Ссылка, по которой вы перешли, устарела!';
export const BACK_TO_LOGIN = 'Вернуться на страницу авторизации';
export const EMAIL_CONFIRM_SUCCESS = 'Спасибо, Ваш аккаунт успешно создан! Пожалуйста, дополните информацию о себе';
export const PASSWORD_MESSAGE =
	'Пароль должен быть от 8 символов: латинские буквы: заглавные буквы, прописные буквы, цифры и специальные символы: !@#$%^&*.,';
